const defaultState = [];


export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_SERVICE_ICONS':
      return action.serviceIcons;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/serviceIcons.jsx